/* Панель темы — полоса провенанса над тремя колонками экрана черновика.
   Это НАШ интерфейс, а не превью, поэтому фирменные токены здесь уместны и обязательны:
   запрет из docs/ui-design.md §6 действует только внутри .tgzone. Ни одного литерального
   цвета — всё из var(--*) (ui-design §2). Плотность своя: паддинг карточки 16px, шаг 4
   (ui-design §4). */

.panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--r-card);
  padding: 16px;
  box-shadow: var(--sh-card);
  min-width: 0;
}

.head {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.line {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: var(--ink-2);
}

.materials {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 4px 0 0;
  padding: 0;
  list-style: none;
}

.material {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border-2);
}

.materialBody {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

/* ДОМЕН КРУПНЕЕ АДРЕСА — главное правило этой панели. Решение принимается по домену
   («это vc.ru или anthropic.com?»), а не по длинному пути, поэтому домен читается первым
   и без усилия, а полный адрес лежит под ним справочной строкой. */
.domain {
  font-family: var(--sans);
  font-size: 17px;
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -0.01em;
  word-break: break-all;
}

/* Полный канонический адрес: приглушён, чтобы не спорить с доменом. break-all, а не
   многоточие: обрезанный адрес скрывает ровно тот хвост, в котором прячется подмена. */
.url {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--sans);
  font-size: 11.5px;
  line-height: 1.4;
  color: var(--muted);
  word-break: break-all;
}

.url:hover {
  color: var(--accent-ink);
}

.url svg {
  flex: none;
}
